import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class ServiceJobProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}
	async CanEditOrDeleteServiceJob(serviceJobId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CanEditOrDeleteServiceJob`, {serviceJobId});
	}
	async GetNextServiceJobNumber(workshopId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNextServiceJobNumber`, {workshopId});
	}
	async CanServiceJobNumberExist(serviceJobNumber: number | null,serviceJobId: number | null, workshopId: number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CanServiceJobNumberExist`, {serviceJobNumber, serviceJobId, workshopId});
	}
}
export const apiProvider = new ServiceJobProvider();
